import { createRoot } from "react-dom/client";
import { AppRouter } from "./AppRouter";

/**
 * Single SPA entry point. Both the marketing landing and the 3D viewer live
 * under one React tree — the previous setup ran a separate Vite-built bundle
 * per HTML document, which forced a full document reload (and a top-nav
 * flash) on every transition between the two surfaces.
 *
 * StrictMode is deliberately NOT enabled: the viewer mounts Three.js inside
 * a useEffect that allocates GPU buffers + spawns workers. StrictMode would
 * mount/unmount that effect twice in dev, doubling renderer instances and
 * causing duplicate canvases. We rely on hand-rolled cleanup in
 * ViewerPage's useEffect instead.
 */

// GH Pages 404.html SPA fallback: when the GH Pages /17CrowHillLn/ deploy
// serves /public/404.html, that file stashes the original deep-link path in
// sessionStorage and bounces here. Replay it into history.replaceState so
// React Router sees the right URL on first paint.
//
// Cloudflare Pages doesn't need this path — public/_redirects handles SPA
// fallback server-side and the page is served at the requested URL directly.
const spaRedirect = sessionStorage.getItem("spa-redirect");
if (spaRedirect) {
  sessionStorage.removeItem("spa-redirect");
  if (spaRedirect !== window.location.pathname + window.location.search + window.location.hash) {
    window.history.replaceState(null, "", spaRedirect);
  }
}

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Missing #root element — check index.html");
}

createRoot(rootEl).render(<AppRouter />);
